export const keyLabels = {
  cmd: "⌘",
  ctrl: "Ctrl",
};

export const isMac = ((): boolean => {
  const platform =
    (navigator as { userAgentData?: { platform: string } }).userAgentData?.platform ??
    navigator.platform;
  return /mac/i.test(platform);
})();

export const isCmdOrCtrlShortcut = (event: KeyboardEvent, key: string): boolean => {
  const modifier = isMac ? event.metaKey : event.ctrlKey;
  return modifier && !event.altKey && !event.shiftKey && event.key.toLowerCase() === key;
};
